import React, { memo } from 'react';
import styles from './ActionTwoHopPopUpModal.module.css';
import ActionButton from 'components/shared/ActionButton/ActionButton';
import Modal from 'components/shared/Modal/Modal';

const ActionTwoHopPopUpModal = ({ onClose, onConfirm, title, content, modalWidth, modalHeight }) => {
  return (
    <Modal animateX={false} close={onClose} noPadding height={modalHeight} width={modalWidth}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {title && <div className={styles.title_container}>{title}</div>}
          <div className={styles.content_container}>{content}</div>
        </div>
        {onConfirm && (
          <div className={styles.button_container}>
            <ActionButton
              title={'Confirm'}
              onClick={onConfirm}
              disabled={false}
              customStyles={{ font: "400 14px 'Rubik'" }}
              backgroundColor={'var(--bermudaBlue)'}
              textColor={'var(--ibmsConsoleTileWhite)'}
              hoveredBackgroundColor={'var(--bermudaBlue-3'}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default memo(ActionTwoHopPopUpModal);
